import { getCSSVariableValue, useMediaQuery } from '@cdab/utils'
import * as sentry from '@sentry/react'
import { useMemo } from 'react'

export type ValidUseCssVariableBreakpointVariableNames =
  | '--tds-grid-lg'
  | '--tds-grid-xs'
  | '--tds-grid-sm'
  | '--tds-grid-md'
  | '--tds-grid-lg'
  | '--tds-grid-xlg'
  | '--tds-grid-xxlg'
  | '--tds-grid-max'

export function useCssVariableBreakpoint(
  cssVariable: ValidUseCssVariableBreakpointVariableNames
): boolean {
  const size = useMemo(() => getCSSVariableValue(cssVariable), [cssVariable])
  const query = `(min-width: ${size})`
  const matches = useMediaQuery(query)

  if (!size) {
    sentry.captureMessage('useCssVariableBreakpoint: size was undefined')
    return false
  }

  return matches
}
